export default __webpack_public_path__ + "static/media/image-gallery.9494eef0.svg";